var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('shop-banner-mobile'),_c('div',{staticClass:"container bg-white"},[_c('div',{staticClass:"row no-gutters justify-content-md-center"},[_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('GiftCard',{attrs:{"storeid":_vm.storeid,"subtitle":_vm.giftCardSubHeaderText,"title":_vm.giftCardHeaderText}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }